import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { TicketDiscountView, TicketDiscountViewProxy } from '../views/ticketdiscount';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { TicketType } from '../types';
import { DiscountType } from '../types';

import { Ticket } from './ticket';

const _schema = {
    "name": "TICKETDISCOUNT",
    "fields": [
        { name: "status", type: "string", default: "AC" },
        { name: "ticket", type: "objid" },
        { name: "discount", type: "objid" },
        { name: "charge", type: "number" },
    ],
    relate: [
        { direction: ">", target: "TICKET", by: "ticket", name: "ticket", reason: "ticket", child: false, class: TicketType },
        { direction: ">", target: "DISCOUNT", by: "discount", name: "discount", reason: "discount", child: false, class: DiscountType }
    ]
} as const;

const _TicketDiscountClass = CreateObject(_schema);
if (!_TicketDiscountClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class TicketDiscount extends _TicketDiscountClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): TicketDiscount {
        return this._Copy(store) as TicketDiscount;
    }

    override get viewProxy(): TicketDiscountView {
        return TicketDiscountViewProxy(this, this.data);
    }

    /** Changelog rows lack `TICKET.discounts`; register on link (see TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || relation !== 'ticket' || !(related instanceof Ticket)){
            return;
        }

        if (related === this.ticket){
            related.AddDiscount(this);
        }
        else {
            related.DelDiscount(this);
        }
    }

    /****************************/
    /* CLASS MEMBERS            */
    /****************************/
    
    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.ticket){
            if ((this.status == 'DE') && !this.Commited){
                this.ticket.DelDiscount(this);
            }
            else {
                this.ticket.DoRefresh(this.table);
            }    
        }
    }    
    
    /****************************/
    /* CUSTOM METHODS           */
    /****************************/

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }    
}